import React from 'react';
import { Col, Row } from 'reactstrap';
import AuthComponent from '../../shared/components/auth/AuthComponent';
import { useHistory, useLocation } from 'react-router-dom';
import { AuthStates } from '../../components/auth/elements/authConsts';
import { Carousel } from 'react-bootstrap';
import styled, { css } from 'styled-components';
import logo from '../../assets/img/logo/logo1.png';



const Section = styled.div`
  padding: 60px 10%; /* Adding horizontal padding */
  text-align: center;

  > div {
    display: flex;
  }
`;

const FeatureImage = styled.img`
  width: 100%;
  height: auto;
  margin-bottom: 15px; // Reduced space
  max-width: 400px; // Default max width
  ${props => props.isMiddleImage && css`
    max-width: 550px;
    min-width: 550px; // Wider for the middle image
  `}

`;


const Title = styled.h2`
  margin-bottom: 30px;
`;
const AuthPage = (props) => {
  const history = useHistory();
  const location = useLocation(); // Use `useLocation` hook to access the current path

  let authState;

  switch (location.pathname) {
    case '/login':
      authState = AuthStates.STATE_LOGIN;
      break;
    case '/signup':
      authState = AuthStates.STATE_SIGNUP;
      break;
    case '/reset_password':
      authState = AuthStates.STATE_RESET_PASSWORD;
      break;
    case '/forgot_password':
      authState = AuthStates.STATE_FORGOT_PASSWORD;
      break;
    case '/verify_email':
      authState = AuthStates.STATE_VERIFY_EMAIL;
      break;
    case '/link_validate_email':
      authState = AuthStates.STATE_BACK_FROM_EMAIL_VALIDATION;
      break;
    default:
      authState = AuthStates.STATE_LOGIN; // Default or fallback state
  }
  const onEmailVerified = () => {
    history.push('/survey/upload_survey_data');
  };

  return (
    <Row
      style={{
        height: '100vh',
        justifyContent: 'center',
      }}
    >
      <Col md={8}>
        <Row>
          <Col  style={{  alignItems: 'center',textAlign:'center',marginTop:'100px' }}>
            <img src={logo} width={140} />
          </Col>
        </Row>
        <Row>
          <Col  style={{  marginTop:'100px' }}>
            <AuthComponent onEmailVerified={onEmailVerified} initialAuthState={authState} />
          </Col>
        </Row>
      </Col>
      <Col md={4} style={{ backgroundColor: 'rgb(242, 245, 247)', alignItems: 'center'}}>
        <Section style={{  marginTop:'100px' }}>
          <Title>Testimonials</Title>
          <Carousel>
            <Carousel.Item>
              <p>"This tool radically transformed our understanding of customer feedback. Highly recommend!"</p>
              <em>- Alex, Product Manager</em>
            </Carousel.Item>
            <Carousel.Item>
              <p>"Thanks to this analytics tool, we've seen a 50% increase in customer satisfaction."</p>
              <em>- Jordan, Customer Success Lead</em>
            </Carousel.Item>
          </Carousel>
        </Section>
      </Col>
    </Row>
  );
};

export default AuthPage;
